import { render } from "./IconFavorite.vue?vue&type=template&id=76b0667a"
import script from "./IconFavorite.vue?vue&type=script&lang=js"
export * from "./IconFavorite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__